import { TextColor } from 'styles/Global/colorSemantic';
import styled, { css } from 'styled-components';
import { font } from './globalStyles';

export type Props = {
    $color?: string;
};

export const Display1_Bold = styled.span<Props>`
    font-size: ${font.size[40]};
    font-weight: ${font.weight.bold};
    line-height: 54px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Display1_SemiBold = styled.span<Props>`
    font-size: ${font.size[40]};
    font-weight: ${font.weight.semiBold};
    line-height: 54px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Display2_Bold = styled.span<Props>`
    font-size: ${font.size[32]};
    font-weight: ${font.weight.bold};
    line-height: 44px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Display2_SemiBold = styled.span<Props>`
    font-size: ${font.size[32]};
    font-weight: ${font.weight.semiBold};
    line-height: 44px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Title1_Bold = styled.span<Props>`
    font-size: ${font.size[28]};
    font-weight: ${font.weight.bold};
    line-height: 38px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Title1_SemiBold = styled.span<Props>`
    font-size: ${font.size[28]};
    font-weight: ${font.weight.semiBold};
    line-height: 38px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Title1_Medium = styled.span<Props>`
    font-size: ${font.size[28]};
    font-weight: ${font.weight.medium};
    line-height: 38px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Title1_Regular = styled.span<Props>`
    font-size: ${font.size[28]};
    font-weight: ${font.weight.regular};
    line-height: 38px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Title2Bold = styled.span<Props>`
    font-size: ${font.size[24]};
    font-weight: ${font.weight.bold};
    line-height: 32px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Title2SemiBold = styled.span<Props>`
    font-size: ${font.size[24]};
    font-weight: ${font.weight.semiBold};
    line-height: 32px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Title2_Medium = styled.span<Props>`
    font-size: ${font.size[24]};
    font-weight: ${font.weight.medium};
    line-height: 32px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Title2_Regular = styled.span<Props>`
    font-size: ${font.size[24]};
    font-weight: ${font.weight.regular};
    line-height: 32px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1Bold = styled.span<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.bold};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1SemiBold = styled.span<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.semiBold};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1_Medium = styled.span<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.medium};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1_Medium_button = styled.button`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.medium};
    line-height: 28px;
`;

export const Body1_Medium_input = styled.input<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.medium};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1_Regular_Button = styled.button<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.medium};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body1Regular = styled.span<Props>`
    font-size: ${font.size[20]};
    font-weight: ${font.weight.regular};
    line-height: 28px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body2Bold = styled.span<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.bold};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Body2BoldSection = styled.section<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.bold};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Body2BoldButton = styled.button<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.bold};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body2SemiBold = styled.span<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.semiBold};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body2Medium = styled.span<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.medium};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body2Regular = styled.span<Props>`
    font-size: ${font.size[18]};
    font-weight: ${font.weight.regular};
    line-height: 26px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3Bold = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.bold};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3SemiBold = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.semiBold};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3SemiBoldButton = styled.button<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.semiBold};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3Medium = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3MediumSection = styled.section<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_neutral};
`;

export const Body3MediumButton = styled.button<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3_Medium_TextArea = styled.textarea<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Body3_Medium_Input = styled.input<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body3Regular = styled.span<Props>`
    font-size: ${font.size[16]};
    font-weight: ${font.weight.regular};
    line-height: 24px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4Bold = styled.span<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.bold};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4BoldButton = styled.button<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.bold};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4SemiBold = styled.span<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.semiBold};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4SemiBoldButton = styled.button<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.semiBold};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4Medium = styled.span<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.medium};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4Medium_Button = styled.button<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.medium};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body4Regular = styled.span<Props>`
    font-size: ${font.size[15]};
    font-weight: ${font.weight.regular};
    line-height: 22px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body5Bold = styled.span<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.bold};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body5SemiBold = styled.span<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.semiBold};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body5Medium = styled.span<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.medium};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body5MediumLabel = styled.label<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.medium};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const BodyFlexMedium = styled.span<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.medium};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
    flex: 1 0 0;
`;
export const Body5_Medium_button = styled.button<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.medium};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Body5Regular = styled.span<Props>`
    font-size: ${font.size[14]};
    font-weight: ${font.weight.regular};
    line-height: 20px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Caption1SemiBold = styled.span<Props>`
    font-size: ${font.size[13]};
    font-weight: ${font.weight.semiBold};
    line-height: 18px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Caption1Medium = styled.span<Props>`
    font-size: ${font.size[13]};
    font-weight: ${font.weight.medium};
    line-height: 18px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
export const Caption1MediumButton = styled.button<Props>`
    font-size: ${font.size[13]};
    font-weight: ${font.weight.medium};
    line-height: 18px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Caption1Regular = styled.span<Props>`
    font-size: ${font.size[13]};
    font-weight: ${font.weight.regular};
    line-height: 18px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Caption2SemiBold = styled.span<Props>`
    font-size: ${font.size[12]};
    font-weight: ${font.weight.semiBold};
    line-height: 16px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Caption2Medium = styled.span<Props>`
    font-size: ${font.size[12]};
    font-weight: ${font.weight.medium};
    line-height: 16px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;

export const Caption2Regular = styled.span<Props>`
    font-size: ${font.size[12]};
    font-weight: ${font.weight.regular};
    line-height: 16px;
    color: ${(props) => props.$color || TextColor.color_text_normal};
`;
